import { apiRequest } from "../utils/apiRequest";

export const getUserProfile = () => async dispatch => {
  return await apiRequest(dispatch, "GET_USER_PROFILE", "get", "/auth/profile/");
};
